import React from 'react';

// Styles & Assets
import styles from './EditColumnsPolls.module.css';

// Hooks
import { useTranslation } from 'react-i18next';

// Interfaces
interface Props {
    children: React.ReactNode
    modalShow: React.Dispatch<React.SetStateAction<boolean>>
}

const EditColumnsPolls: React.FC<Props> = ({ children, modalShow }) => {

    const { t } = useTranslation();

    return (
        <div className={`${styles.editColumnsDialogContainer} dialog`}>
            <h1 className='dialogTitle'>{t('select_data')}</h1>
            <div className={styles.editColumnsOptionsContainer}>
                <div className={styles.rowOptionsContainer}>
                    <h2 className='dialogSubTitle'>{t('polls')}</h2>
                    <div className={styles.checkboxGridContainer}>
                        {children}
                    </div>
                </div>
            </div>
            <div className={styles.bottomButtonContainer}>
                <button onClick={() => modalShow(false)} className={styles.bottomButton}>
                    {t('close')}
                </button>
            </div>
        </div>
    );
};

export default EditColumnsPolls;